<template>
  <!-- 封装城市复选框 -->
  <div>
    <div>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选
      </el-checkbox>

      <el-checkbox-group
        v-model="checkedCities"
        @change="handleCheckedCitiesChange"
      >
        <div v-for="(item, index) in city_data" :key="index">
          <el-checkbox
            v-for="item1 in item"
            v-if="item1.alias != '主库'"
            :label="item1.city_tag"
            :key="item1.include"
            >{{ item1.include }}</el-checkbox
          >
        </div>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
var _this;
import bus from "@/utils/bus";

export default {
  name: "checkCityBtn",

  data() {
    return {
      cities: [],

      city_data: {},
      checkAll: false,

      //全选按钮的短横，当有部分城市选择的时候展示
      isIndeterminate: false,

      checkedCities: [],
    };
  },
  props: {
    data: [],
  },
  created() {
    // 页面创建完成,创建vue实例
    _this = this;
    // 通过 获取父组件传过来的数据，添加页面传过来的是空数据，详情页面传过来的是详情接口返回的城市
    bus.$on("cities", (msg) => {
      _this.checkedCities = msg;
      _this.isIndeterminate = false;
      _this.checkAll = false;


 
    });

    _this.getCityArray();
  },
  mounted() {
    // 页面挂载 获取dom节点
  },
  methods: {
    // 获取城市
    getCityArray() {
      _this.city_data = {};
      _this.cities = [];
      this.$post("city/getCityLists", "", "", "normal")
        .then((res) => {
          _this.city_data = res.data;

          for (const key in res.data) {
            res.data[key].forEach((element) => {
              if (element.city_tag != "ONLINE_MAIN") {
                _this.cities.push(element);
              }
            });
          }
        })
        .catch((err) => {});
    },
    // 城市全选
    handleCheckAllChange(val) {
      if (val) {
        this.checkedCities = [];
        for (let j in _this.city_data) {
          for (let i = 0; i < _this.city_data[j].length; i++) {
            if (_this.city_data[j][i].city_tag != "ONLINE_MAIN") {
              this.checkedCities.push(_this.city_data[j][i].city_tag);
            }

            // _this.submit_data.all_city = 1;
          }
        }
        // 上面push方法导致数据出现重复，下面代码是数组去重
        // this.checkedCities = [...new Set(this.checkedCities)];
      } else {
        _this.checkedCities = [];
        // _this.submit_data.all_city = 0;
      }

      this.$nextTick(() => {
        // 触发父组件自定义事件，把选择的城市传给父组件
        this.$emit("getCities", {
          checkedCities: this.checkedCities,
          checkAll: this.checkAll,
        });
      });

      this.isIndeterminate = false;
    },
    // 勾选城市
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;

      this.checkAll = checkedCount === _this.cities.length;
      // 触发父组件自定义事件，把选择的城市传给父组件

      this.$emit("getCities", {
        checkedCities: this.checkedCities,
        checkAll: this.checkAll,
      });

      _this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
      // if (checkedCount > 0 && checkedCount < this.cities.length) {
      //   this.isIndeterminate = true;
      // } else {
      //   this.isIndeterminate = false;
      // }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/utils/cityChangeCheckbox.vue